// How long a session ran, and whether that makes it a short one.
//
// A session under three minutes is one the teacher's report treats specially:
// `ParsedSummary` drops four whole sections for it and leaves only Session
// Headlines. Two surfaces need to know it — the teacher's report, which acts on
// it, and the admin prompt console, which says out loud that a teacher would
// see less than the console is showing — so there is ONE definition of it here
// rather than a second one written from memory.

export const SHORT_SESSION_MS = 3 * 60 * 1000;

/**
 * How long a session ran, in milliseconds.
 *
 * @param {object|null|undefined} value A session row: started_at, ended_at.
 * @returns {number|null} Null when the session never ended, which is not a
 *   duration of zero — it is no duration at all.
 */
export const sessionDurationMs = (value) =>
  value?.ended_at ? new Date(value.ended_at) - new Date(value.started_at) : null;

/**
 * Whether a duration is a short session's.
 *
 * Strictly under three minutes: three minutes on the nose is an ordinary
 * session, and the comparison decides what four sections a teacher sees.
 *
 * @param {number|null|undefined} durationMs
 * @returns {boolean}
 */
export const isShortDuration = (durationMs) =>
  durationMs !== null && durationMs < SHORT_SESSION_MS;

/**
 * Whether a session row is a short session's.
 *
 * @param {object|null|undefined} value A session row: started_at, ended_at.
 * @returns {boolean} False for a session that never ended: with no end time
 *   there is no duration, so there is nothing to be short.
 */
export const isShortSession = (value) => isShortDuration(sessionDurationMs(value));
